import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function WatchersIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M20.3 6.625H10.8C8.7043 6.625 7 8.30687 7 10.375V21.625C7 23.6931 8.7043 25.375 10.8 25.375H20.3C22.3957 25.375 24.1 23.6931 24.1 21.625V10.375C24.1 8.30687 22.3957 6.625 20.3 6.625ZM22.2 21.625C22.2 22.66 21.3488 23.5 20.3 23.5H10.8C9.7531 23.5 8.9 22.66 8.9 21.625V10.375C8.9 9.34188 9.7531 8.5 10.8 8.5H20.3C21.3488 8.5 22.2 9.34188 22.2 10.375V21.625Z"
        fill="currentColor"
      />
      <path
        d="M25.05 10.375C24.5256 10.375 24.1 10.795 24.1 11.3125V13.1875C24.1 13.705 24.5256 14.125 25.05 14.125C25.5744 14.125 26 13.705 26 13.1875V11.3125C26 10.795 25.5744 10.375 25.05 10.375Z"
        fill="currentColor"
      />
      <path
        d="M22.5914 7.55312C21.7136 5.8375 21.25 3.895 21.25 1.9375C21.25 1.42 20.8244 1 20.3 1H10.8C10.2756 1 9.85 1.42 9.85 1.9375C9.85 3.895 9.3864 5.8375 8.5086 7.55312C8.2711 8.01437 8.4611 8.57875 8.9285 8.81312C9.3959 9.04937 9.9678 8.86 10.2053 8.39875C11.0755 6.69625 11.5923 4.80438 11.7196 2.875H19.3823C19.5077 4.80438 20.0245 6.69625 20.8966 8.39875C21.0638 8.72313 21.3963 8.9125 21.744 8.9125C21.8884 8.9125 22.0347 8.88062 22.1715 8.81312C22.6389 8.57875 22.827 8.01625 22.5914 7.55312Z"
        fill="currentColor"
      />
      <path
        d="M22.1734 23.1887C21.706 22.9562 21.1322 23.14 20.8966 23.6031C20.0264 25.3019 19.5077 27.1956 19.3823 29.125H11.7196C11.5923 27.1956 11.0755 25.3019 10.2053 23.6031C9.9678 23.1419 9.394 22.9562 8.9285 23.1887C8.4592 23.4231 8.2711 23.9875 8.5086 24.4487C9.3864 26.1625 9.85 28.1031 9.85 30.0625C9.85 30.58 10.2756 31 10.8 31H20.3C20.8244 31 21.25 30.58 21.25 30.0625C21.25 28.1031 21.7136 26.1625 22.5933 24.4487C22.8308 23.9875 22.6408 23.4231 22.1734 23.1887Z"
        fill="currentColor"
      />
      <path
        d="M19.0726 18.1506L16.5 15.6119V11.3125C16.5 10.795 16.0744 10.375 15.55 10.375C15.0256 10.375 14.6 10.795 14.6 11.3125V16C14.6 16.2494 14.7007 16.4875 14.8774 16.6638L17.7274 19.4763C17.9136 19.6581 18.1568 19.75 18.4 19.75C18.6432 19.75 18.8864 19.6581 19.0726 19.4763C19.4431 19.1106 19.4431 18.5163 19.0726 18.1506Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
